import { Link } from "react-router-dom";
import Slider from "react-slick";
import { BaseUrl } from "../../helper/BaseUrl";
import React, { useState, useEffect } from "react";

  const settings = {
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    pauseOnHover: false,
    arrows: false,
  autoplaySpeed: 4000,
   speed: 5000,
    cssEase: "ease",
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1 }
      }
    ]
  };

export default function HomeBlog({initialData}) {
    const [allData, setAllData] = useState(Array.isArray(initialData) ? initialData : []);
    // API Calling
    const fetcher = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/blogs`, {
          method: 'GET',
        });
  
        const result = await response.json();
  
        if (result.blogs === false) {
          throw new Error(`API error: ${result.message}`);
        }
        setAllData(Array.isArray(result.blogs) ? result.blogs : []);
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };
  
    useEffect(() => {
      if (Array.isArray(initialData) && initialData.length > 0) {
        setAllData(initialData);
        return;
      }
      fetcher();
    }, [initialData])
  
    if (!Array.isArray(allData)) {
      return <div style={{ height: "100vh", width: "100%" }}></div>;
    }

  // const blogs = [
  //   {
  //     category: "blog",
  //     title: "State of AI in Freight Procurement ft. AI Agents",
  //     link: "/blog-detail", 
  //     img: "/assets/images/blog-new-image1.webp"
  //   },
  //   {
  //     category: "News",
  //     title: "Why logistics experts believe in a future of AI-powered freight procurement",
  //     link: "/blog-detail",
  //     img: "/assets/images/blog-new-image2.webp"
  //   },
  //   {
  //     category: "blog",
  //     title: "How CSCOs can make gen AI honor its productivity promise in 2025",
  //     link: "/blog-detail",
  //     img: "/assets/images/blog-new-image3.webp"
  //   },
  //   {
  //     category: "blog",
  //     title: "State of AI in Freight Procurement ft. AI Agents",
  //     link: "/blog-detail",
  //     img: "/assets/images/blog-new-image1.webp"
  //   }
  // ];

  
  return (

    <>
    <section className="blog-section home-blog-section space">
      <div className="container">
        <div className="row">
          <div className="col-sm-7 col-md-9">
            <div className="blog-content">
              <div className="heading">Discover insights & best practices</div>
            </div>
          </div>
          <div className="col-sm-5 col-md-3">
            <div className="blog-btn">
              <Link to="/blog-page" className="view-more theme-btn">
                <span>VIEW ALL</span>
              </Link>
            </div>
          </div>
        </div>

        <div className="blog-slider mt-4">
          <Slider {...settings}>
            {allData.slice(0,4).map((blog, i) => (
              <div className="blog-col" key={i}>
                <div className="blog-inner">
                  <div className="content">
                    {/* <div className="category theme-btn">{blog.category_name}</div> */}
                    <div className="category theme-btn"> {blog.category_name?.split(" ").slice(0, 3).join(" ")}</div>
                    <div className="heading">
                      <Link to={`/${blog.slug}`}>{blog.name}</Link>
                    </div>
                  </div>
                  <div className="image-wrapper">
                  <img src={`${BaseUrl}${blog.image}`}   className="img-responsive"  alt={blog.name}   loading="lazy" />
                                
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
    </>

  )
}
